const data = [
  {
    id: 1,
    name: "Savory Rice",
    img: "/images/plate-of-chineserice.jpeg",
    description:
      "Savory rice with vermicelli fried noodles served with shredded beef in green pepper sauce, chicken in curry sauce and prawns in chili sauce",
    supplements: [
      "Savory Rice",
      "Vermicelli",
      "Fried Noodles",
      "Shredded Beef",
      "Chicken In Curry Sauce",
      "Praws in Chili Sauce",
    ],
    featured: false,
    price: 600,
  },
  {
    id: 2,
    name: "Amala and Ewedu",
    img: "/images/plate-of-Amala.jpg",
    description:
      "Amala served with Ewedu, Gbegiri, Assorted Meats and Fresh Fish",
    supplements: ["Amala", "Ewedu", "Gbegiri", "Assorted Meat", "Fresh fish"],
    featured: false,
    price: 600,
  },
  {
    id: 3,
    name: "Jollof Rice",
    img: "/images/plate-of-jollof.jpeg",
    description:
      "Jollof rice, fried rice, moi moi, chicken or fresh fish and assorted meat",
    supplements: [
      "Jollof Rice",
      "Fried Rice",
      "Moi Moi",
      "Chicken or Fresh Fish",
      "Assorted Meat",
    ],
    featured: false,
    price: 600,
  },
  {
    id: 4,
    name: "Ofada Rice",
    img: "/images/plate-of-Ofada.jpg",
    description:
      "Ofada rice served with Fried Plantain, Assorted Meats and Fresh Fish",
    supplements: [
      "Ofada Rice",
      "Fried Plantain",
      "Assorted Meats",
      "Fresh Fish",
    ],
    featured: true,
    price: 600,
  },
  {
    id: 5,
    name: "Ewa Aganyi",
    img: "/images/plate-of-Aganyi.jpg",
    description:
      "Ewa Aganyin served with Friend Plantain, Fried Fish and Assorted Meats",
    supplements: [
      "Ewa Agayin",
      "Fried Plantain",
      "Fried Fish",
      "Assorted Meats",
    ],
    featured: false,
    price: 600,
  },
  {
    id: 6,
    name: "Semo and Efo",
    img: "/images/plate-of-semo.jpg",
    description:
      "Semovita or pounded yam with efo riro/ efo elegusi served with chicken and fresh fish",
    supplements: [
      "Semovita or Pounded Yam",
      "Efo Riro or Efo Elegusi",
      "Chicken",
      "Fried Fish",
    ],
    featured: false,
    price: 600,
  },
  {
    id: 7,
    name: "Rice",
    img: "/images/plate-of-Rice.jpg",
    description: "Sweet Beans",
    supplements: ["Dodo", "Eja", "Pomo"],
    featured: false,
    price: 600,
  },
];

export const allImages = [
  "/images/efo.jpg",
  "/images/at-an-event.jpg",
  "/images/Waiters Serving.jpg",
  "/images/Moi and Asaro in Dish.jpg",
  "/images/Fresh Fish 1.jpg",
  "/images/Egusi in Dish.jpg",
  "/images/Don't Know (2).jpg",
  "/images/dishes (2).jpg",
];

export const gallery = [
  "/images/gallery1.jpeg",
  "/images/gallery2.jpeg",
  "/images/gallery3.jpeg",
  "/images/gallery4.jpeg",
  "/images/gallery5.jpeg",
  "/images/gallery6.jpeg",
  "/images/gallery7.jpeg",
  "/images/gallery8.jpeg",
  "/images/gallery9.jpeg",
  "/images/gallery10.jpeg",
  "/images/gallery11.jpeg",
  "/images/gallery12.jpeg",
  "/images/gallery13.jpeg",
  "/images/gallery14.jpeg",
  "/images/gallery15.jpeg",
];

export default data;
